<div class="container-fluid ml-n2">
  <div v-if="isTestMode" class="row text-center">
    <div class="col-12">
      <label class="sub-title-style" style="color: red;">{{ $t('message.label_title_training_mode') }}</label>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="ml-2 mr-2" v-if="useVehicleScreenTabs">
        <!-- Vehicle 画面用のヘッダタブ -->
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <button v-if="!isTechnicalHq && isDisplayReproTabs && isReproVisible && isDisplayTab" class="nav-link"
              :class="{ 'active': activeTabArray[0] }" @click="switchFunctionTab(funcRepro)">
              {{ $t(reproFuncTabTitle) }}
            </button>
          </li>
        </ul>
      </div>
      <b-nav tabs class="ml-2 mr-2" v-else>
        <!-- System 画面用のヘッダタブ -->
        <b-nav-item disabled>{{ $t('message.header_vehicle_system_tab_flash') }}</b-nav-item>
      </b-nav>
    </div>
    <div class="col-12">
      <!-- SU法規対象のシステム一覧では、許諾状態が更新されたときにテーブルを取得し直す -->
      <!-- SU法規対象のシステム一覧では、法規適合化操作が行われたときテーブルを更新する -->
      <!-- 許諾更新後のテーブル再取得成功でダイアログを表示させない特別対応 -->
      <router-view :tableData="systemTables" @selectReproTableRow="clickReproTableRow"
        @selectDtcTableRow="clickDtcTableRow" @setVehicleTabsAvailable="setVclScreenTabsAvailable"
        @switchPublishmentMode="switchPublishmentMode" @setModalQueueAvailable="setModalQueueAvailable"
        @refreshAllReproSystems="refreshAllReproSystems" @runModalQueue="runModalQueue"
        @changeTableTypes="changeReproFuncTabName" @getPfcFile="getPfcFileList" @serialNoDialog="serialNoControl"
        @defaultTable="refreshAllReproSystems" @selectReproSystem="selectReproSystem"
        @callSelectReproEcu="callSelectReproEcu" @updateTargetUnitData="updateTargetUnitData"
        @openConsentModal="openConsentModal" v-slot="{ Component }">
        <component ref="informationContents" :is="Component" />
      </router-view>
    </div>
  </div>

  <!-- 機能向上・復元のパスワード確認ダイアログ -->
  <div>
    <b-modal v-model="showModalPassword" id="modal-pfc-file-password-input" size="lg" header-bg-variant="secondary"
      header-text-variant="light" no-stacking no-close-on-backdrop centered no-close-on-esc
      @ok="checkPfcFilePassword()">
      <template v-slot:header>
        <div class="text-center w-100">
          {{ $t("message.messege_title_password") }}
        </div>
      </template>
      <template v-slot:default>
        <div class="container-fluid mt-2 mb-2">
          <div class="row no-gutters">
            <!-- 説明文 -->
            <div class="mb-3" v-html="$t('message.messege_repro_merchantability_password')"></div>
            <!-- 入力フォーム -->
            <div class="col-12">
              <b-form-group class="form-group">
                <b-input-group>
                  <b-form-input type="password" v-model="pfcFilePassword" size="sm" autocomplete="off">
                    {{ pfcFilePassword }}
                  </b-form-input>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="text-center w-100">
          <b-button size="sm" variant="outline-primary" class="ml-2 mr-2" @click="showModalPassword=false">
            {{ $t('message.common_button_cancel')}}
          </b-button>
          <b-button size="sm" variant="primary" @click="checkPfcFilePassword()" class="ml-2 mr-2">
            {{ $t("message.common_button_ok") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>

  <!-- 許諾変更ダイアログ -->
  <b-modal v-model="showModalConsent" id="modal-consent" size="lg" header-bg-variant="secondary"
    header-text-variant="light" no-stacking no-close-on-backdrop centered no-close-on-esc scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_vehicle_system_swid_update_consent') }}
      </div>
    </template>

    <template v-slot:default>
      <div class="row" :class="{ 'scroll-hide': processing }" style="font-weight: bold;">
        <div class="col-12">
          {{ $t("message.label_vehicle_system_current_swid_state") }}: "{{ $t(consentState.label) }}"
        </div>
        <div class="col-12 mt-2">
          {{ $t("message.label_vehicle_system_target_system") }}
          <div class="row" v-for="ecu in consentTable.ecus">
            <div class="col-5">
              <label class="pl-3">{{ ecu.name }}</label>
            </div>
            <div class="col-7">
              <label>{{ ecu.current }}<span>
                  <svg class="mb-1 mr-2 ml-2" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                    viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round"
                    stroke-linejoin="round">
                    <path d="M5 12h13M12 5l7 7-7 7" />
                  </svg></span>{{ ecu.latest }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-12" v-html="$t('message.message_vehicle_system_swid_update_consent_caution')"></div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-center">
        <b-button size="sm" variant="outline-primary" @click="showModalConsent=false" class="ml-2 mr-2"
          :disabled="processing">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button v-if="consentState.order !== 0" size="sm" variant="primary" @click="updateConsentState('consented')"
          class="ml-2 mr-2" :disabled="processing">
          {{ $t("message.button_vehicle_system_consent") }}
        </b-button>
        <b-button v-if="consentState.order !== 1" size="sm" variant="primary" @click="updateConsentState('rejected')"
          class="ml-2 mr-2" :disabled="processing">
          {{ $t("message.button_vehicle_system_not_consent") }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <processing-view :processing="processing"></processing-view>
</div>